// src/hooks/useWithdrawal.js
import { useEffect, useState } from "react";
import { fetchWithdrawalPage } from "../api/withdrawal";

export default function useWithdrawalList({
    market,
    page = 1,
    pageSize = 10,
    enabled = true, // 👈 флаг
    reloadToken = 0,
}) {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!enabled) return;   // 👈 не грузим, если выключен
        let cancelled = false;

        async function load() {
            try {
                setLoading(true);
                const { rows: dataRows, total: count } = await fetchWithdrawalPage({
                    market,
                    page,
                    pageSize,
                });

                if (!cancelled) {
                    setRows(dataRows);
                    setTotal(count);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        load();
        return () => { cancelled = true; };
    }, [enabled, market, page, pageSize, reloadToken]);

    // если выключен — возвращаем пустые значения, но хук вызван
    return {
        rows: enabled ? rows : [],
        total: enabled ? total : 0,
        loading: enabled ? loading : false,
    };
}
